import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-total-dispo-percent',
    templateUrl: './total-dispo-percent.component.html',
    styleUrls: ['./total-dispo-percent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalDispoPercentComponent implements OnInit {
    label: string;
    amount: number;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getTotalDispoPercent().subscribe(r => {
            this.label = r.value.label;
            this.amount = r.value.value;
        });
    }
}
